import React, { useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { BasicInfo } from './components/BasicInfo'
import { ApiErrorType, CrewDataMutateType, CrewDataType, CrewSingleGetType, ResponseType } from 'src/types'
import { Get, Post } from 'src/apis/apiWithType'
import { useMutation, useQuery } from 'react-query'
import { Button } from 'src/components/UI'
import { toast } from 'react-toastify'
import { AddressInfo } from './components/AddressInfo'
import { WorkInfo } from './components/WorkInfo'
import moment from 'moment-jalaali'
import { AgentInfo } from './components/AgentInfo'
import { useSearchParams } from 'react-router-dom'
import { useCrewInfo } from '../../hooks'
import Loading from 'src/components/Loading'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { createFormData } from 'src/utils/new'

export interface CrewMutateFormType extends CrewDataMutateType {
  bth_day: string,
  bth_month: string,
  bth_year: string
}

export const Information = ({ id }: { id?: string }) => {

  const methods = useForm<CrewMutateFormType>()

  const { t } = useTranslation()

  const { handleSubmit, formState: { errors }, reset, watch } = methods

  const { dispatch } = useCrewInfo()

  const [params] = useSearchParams()

  const mode = params.get('mode')

  const crewId = params.get('id')

  const user = useSelector((state) => (state as any).user.user)

  const isAgent = user?.role_key === "agent"
  const isAdmin = user?.role_key === "super_admin"

  const path = isAdmin ? 'admin' : 'agent'



  const { mutate, isLoading } = useMutation<ResponseType<CrewDataType>, ApiErrorType, Partial<CrewDataMutateType>, {}>({
    mutationFn: async ({ picture, ...data }) => {

      const path = isAdmin ? 'admin' : 'agent'

      try {

        if (typeof picture == 'object' && crewId)
          await Post(`agent/crews/${crewId}/upload-avatar`, createFormData({ avatar: picture }))
      } catch (error) {

      }


      if (crewId)
        return Post(`/${path}/crews/${crewId}/update`, { ...data, form: `${path}_update_form` })

      return Post(`/${path}/crews/store`, { ...data, form: `${path}_store_form` })
    },
    mutationKey: ['MutateFile', id],
    onSuccess: (res) => {
      toast.success(res.msg)
      refetch()
      dispatch({ step: 2, selectedCrew: res.details.data })
    },
    onError: (error) => {
      toast.error(error?.data?.message)
    }
  })

  const handleMutateCrewData = ({ bth_day, bth_month, bth_year, job_id, level_id, ...data }: CrewMutateFormType) => {

    const birthday = moment(new Date(parseFloat(bth_year), parseFloat(bth_month) - 1, parseFloat(bth_day)).toLocaleDateString()).format('YYYY-MM-DD')

    mutate({ ...data, birth_date: birthday, job_id: job_id.toString(), level_id: level_id.toString() })
  }


  const { data, isLoading: loadingOfCrew, refetch } = useQuery<ResponseType<CrewSingleGetType>, ApiErrorType>({
    queryFn: ({ queryKey }) => queryKey?.[1] ? Get(`agent/profile/crews/${queryKey?.[1]}`) : Promise.reject(),
    queryKey: ['GetCrewInfo', crewId],
    enabled: !!crewId && mode == 'edit',
    onError: (error) => {
      toast.error(error?.data?.message)
    }
  })


  useEffect(() => {

    if (data?.details?.data) {

      const { AGENT_ID, level_id, job_id, exbulk, excontiner, exfueled, exlandycraft, gender, name, ref_id, picture, nationality, career_type, last_name, home_address, work_address, work_phone, phone, father_name, ship_type_id, place_of_birth, birth_date, passport_country, passport_no, cdc_no } = data.details.data

      reset({
        agent_id: AGENT_ID, level_id, job_id, exbulk,
        excontiner, exfueled, exlandycraft, work_address, work_phone, phone,
        ...(gender ? ({ gender: gender.toString() }) : ({})), father_name, home_address,
        last_name, name, nationality, passport_country, place_of_birth, career_type, picture, passport_no, cdc_no, ...(!!ref_id ? ({ ref_id }) : ({})),
        ship_type_id, bth_day: parseFloat(moment(birth_date).format('DD')).toString(), bth_month: (parseFloat(moment(birth_date).format('MM'))).toString(), bth_year: moment(birth_date).format('YYYY')
      })
    }

  }, [data])


  console.log(watch('bth_day'))


  return (
    <FormProvider {...methods}>

      {loadingOfCrew
        ? <div className='flex flex-row gap-4 items-center  my-container bg-white w-full justify-center p-8 py-10  text-gray-700 rounded-lg'>
          <span>{t('LoadingCrewData')}</span>
          <Loading />
        </div>

        : <form className='my-container py-4 flex flex-col gap-8' onSubmit={handleSubmit(handleMutateCrewData)}>

          <BasicInfo mode={mode} />

          <AddressInfo />

          <WorkInfo />

          <AgentInfo />

          <div className='flex flex-row justify-end '>
            <Button loading={isLoading} style={{ width: 'fit-content' }} keyTitle={mode == 'add' ? 'saveInformation' : 'saveChanges'}></Button>
          </div>

        </form>}

    </FormProvider>
  )
}
